export const DASHBOARD_INTEGRATIONS = 'dashboard_integrations';
